import { useState, useEffect } from 'react'
import Header from './components/Header'
import Hero from './components/Hero'
import Products from './components/Products'
import News from './components/News'
import Footer from './components/Footer'
import ContactSidebar from './components/ContactSidebar'
import AirHeaterManualPage from './pages/AirHeaterManualPage'
import WaterHeaterManualPage from './pages/WaterHeaterManualPage'
import BurnerManualPage from './pages/BurnerManualPage'
import WoodFireplaceManualPage from './pages/WoodFireplaceManualPage'
import TroubleshootingManualPage from './pages/TroubleshootingManualPage'
import AirGranuleModelsPage from './pages/AirGranuleModelsPage'
import WaterGranuleModelsPage from './pages/WaterGranuleModelsPage'
import WoodFireplaceModelsPage from './pages/WoodFireplaceModelsPage'
import AirHeaterMaintenanceVideosPage from './pages/AirHeaterMaintenanceVideosPage'
import AboutPage from './pages/AboutPage'
import ContactPage from './pages/ContactPage'
import ResourcesPage from './pages/ResourcesPage'
import NewsPage from './pages/NewsPage'
import NewsDetailPage from './pages/NewsDetailPage'
import ProductsPage from './pages/ProductsPage'
import CompanyDetailPage from './pages/CompanyDetailPage'

function App() {
  const [currentPage, setCurrentPage] = useState('home')

  useEffect(() => {
    const handleLocationChange = () => {
      const path = window.location.pathname
      if (path === '/air-heater-manual') {
        setCurrentPage('air-heater-manual')
      } else if (path === '/water-heater-manual') {
        setCurrentPage('water-heater-manual')
      } else if (path === '/burner-manual') {
        setCurrentPage('burner-manual')
      } else if (path === '/wood-fireplace-manual') {
        setCurrentPage('wood-fireplace-manual')
      } else if (path === '/troubleshooting-manual') {
        setCurrentPage('troubleshooting-manual')
      } else if (path === '/air-granule-models') {
        setCurrentPage('air-granule-models')
      } else if (path === '/water-granule-models') {
        setCurrentPage('water-granule-models')
      } else if (path === '/wood-fireplace-models') {
        setCurrentPage('wood-fireplace-models')
      } else if (path === '/air-heater-maintenance-videos') {
        setCurrentPage('air-heater-maintenance-videos')
      } else if (path === '/about') {
        setCurrentPage('about')
      } else if (path === '/contact') {
        setCurrentPage('contact')
      } else if (path === '/resources') {
        setCurrentPage('resources')
      } else if (path === '/news') {
        setCurrentPage('news')
      } else if (path === '/news-detail') {
        setCurrentPage('news-detail')
      } else if (path === '/products') {
        setCurrentPage('products')
      } else if (path === '/company-detail') {
        setCurrentPage('company-detail')
      } else {
        setCurrentPage('home')
      }
    }

    // Initial check
    handleLocationChange()

    // Listen for popstate changes (back/forward buttons)
    window.addEventListener('popstate', handleLocationChange)

    return () => window.removeEventListener('popstate', handleLocationChange)
  }, [])

  if (currentPage === 'air-heater-manual') {
    return <AirHeaterManualPage />
  }

  if (currentPage === 'water-heater-manual') {
    return <WaterHeaterManualPage />
  }

  if (currentPage === 'burner-manual') {
    return <BurnerManualPage />
  }

  if (currentPage === 'wood-fireplace-manual') {
    return <WoodFireplaceManualPage />
  }

  if (currentPage === 'troubleshooting-manual') {
    return <TroubleshootingManualPage />
  }

  if (currentPage === 'air-granule-models') {
    return <AirGranuleModelsPage />
  }

  if (currentPage === 'water-granule-models') {
    return <WaterGranuleModelsPage />
  }

  if (currentPage === 'wood-fireplace-models') {
    return <WoodFireplaceModelsPage />
  }

  if (currentPage === 'air-heater-maintenance-videos') {
    return <AirHeaterMaintenanceVideosPage />
  }

  if (currentPage === 'about') {
    return <AboutPage />
  }

  if (currentPage === 'contact') {
    return <ContactPage />
  }

  if (currentPage === 'resources') {
    return <ResourcesPage />
  }

  if (currentPage === 'news') {
    return <NewsPage />
  }

  if (currentPage === 'news-detail') {
    return <NewsDetailPage />
  }

  if (currentPage === 'products') {
    return <ProductsPage />
  }

  if (currentPage === 'company-detail') {
    return <CompanyDetailPage />
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <ContactSidebar />
      <main>
        <Hero />
        <Products />
        <News />
      </main>
      <Footer />
    </div>
  )
}

export default App
